import { apiInstance } from "./networking";
export const eddUploadDocument = async (payload) => {
    try {
        const { data } = await apiInstance.post(
            `primary/upload-edd`,
            payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("token"),
                },
            }
        );
        return data; 
    } catch (error) {
        console.error("EDD Upload API Error:", error);
        throw error;
    }
};
